import React from 'react';
import { MoonIcon, ClockIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="relative z-10 min-h-[90vh] flex flex-col justify-center items-center px-4 pt-20 pb-16 text-center" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <FadeIn delay={0.1} data-id="element-48">
          <div className="flex justify-center mb-6" data-id="element-49">
            <div className="inline-flex items-center justify-center p-3 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm" data-id="element-50">
              <MoonIcon className="w-6 h-6 text-blue-400 mr-2" data-id="element-51" />
              <span className="text-sm font-medium tracking-wider text-blue-200 uppercase" data-id="element-52">
                Para mentes que no se apagan
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-53">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 text-glow" data-id="element-54">
            Cómo Silenciar Tu Mente en 180 Segundos y Volver a Dormir Profundo
            <span className="block text-2xl md:text-3xl lg:text-4xl text-blue-300 mt-4 font-normal italic" data-id="element-55">
              (Sin Pastillas ni Meditaciones Frustrantes)
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-56">
          <h2 className="text-lg md:text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-57">
            El Método de "Vaciado Mental" diseñado específicamente para
            profesionales y personas con ansiedad que no logran "apagar" el
            cerebro al tocar la almohada.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} className="glass-card p-6 md:p-8 max-w-3xl mx-auto text-left relative overflow-hidden" data-id="element-58">
          <div className="absolute top-0 left-0 w-1 h-full bg-blue-500/50" data-id="element-59"></div>
          <div className="flex items-start gap-4" data-id="element-60">
            <ClockIcon className="w-6 h-6 text-amber-400 flex-shrink-0 mt-1" data-id="element-61" />
            <div className="space-y-4 text-gray-200" data-id="element-62">
              <p data-id="element-63">
                Son las 2:30 AM. Estás agotado física y mentalmente, pero tus
                ojos están abiertos como platos. Tu cerebro ha decidido que este
                es el momento perfecto para repasar ese error que cometiste hace
                tres años, o para entrar en pánico por la lista de pendientes de
                mañana.
              </p>
              <p data-id="element-64">
                Calculas cuántas horas de sueño te quedan si te duermes "ahora
                mismo", y ese mismo cálculo te genera más ansiedad,
                manteniéndote despierto en un ciclo cruel que parece no tener
                fin.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} className="mt-12" data-id="element-65">
          <a href="#offer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-slate-900 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full hover:from-amber-300 hover:to-amber-400 transition-all duration-300 shadow-[0_0_20px_rgba(245,158,11,0.4)] hover:shadow-[0_0_30px_rgba(245,158,11,0.6)] transform hover:-translate-y-1" data-id="element-66">
            ¡QUIERO DORMIR BIEN HOY!
          </a>
        </FadeIn>
      </div>
    </section>;
}